exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container___1t2-r {\n  background-color: #e5eef7;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100vh;\n  overflow: hidden;\n}\n.appImage___2-8X8 {\n  padding: 0 20px;\n  width: 100%;\n}\n.modal___5R_gb {\n  position: fixed;\n  z-index: 2000;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100vh;\n  overflow-y: hidden;\n}\n.modalParent___2ZY74 {\n  height: 100vh;\n  overflow: hidden;\n}\n.hideForModal___zGzKu {\n  display: none;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container___1t2-r",
	"appImage": "appImage___2-8X8",
	"modal": "modal___5R_gb",
	"modalParent": "modalParent___2ZY74",
	"hideForModal": "hideForModal___zGzKu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/pages/postOnboard/AppDownload/AppDownload.module.less
// module id = 2073
// module chunks = 71